import React from 'react';
import { roleConstants } from '../../constants/roleConstants';
import { PrivateRoute } from './PrivateRoute';

export const ClientRoute = ({ ...props }) => {
  return <PrivateRoute {...props} role={roleConstants.ROLE_INDIVIDUAL} />;
};
